/**
 * FAQ Section - Accordion & Tab Functionality
 * BEM Methodology
 */

class SectionFAQ {
  constructor(section) {
    this.section = section;
    this.tabs = this.section.querySelectorAll('.section-faq__tab');
    this.categories = this.section.querySelectorAll('.section-faq__category');
    this.items = this.section.querySelectorAll('.section-faq__item');

    this.init();
  }

  init() {
    this.setupTabs();
    this.setupAccordion();
  }

  /**
   * Setup tab functionality
   */
  setupTabs() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const categoryId = tab.getAttribute('data-category');
        this.switchCategory(categoryId);
      });
    });
  }

  /**
   * Switch between categories
   * @param {string} categoryId - The category block ID
   */
  switchCategory(categoryId) {
    // Update active tab
    this.tabs.forEach((tab) => {
      if (tab.getAttribute('data-category') === categoryId) {
        tab.classList.add('section-faq__tab--active');
      } else {
        tab.classList.remove('section-faq__tab--active');
      }
    });

    // Update active category content
    this.categories.forEach((category) => {
      if (category.getAttribute('data-category-content') === categoryId) {
        category.classList.add('section-faq__category--active');
      } else {
        category.classList.remove('section-faq__category--active');
        // Close all accordions in hidden categories
        const hiddenItems = category.querySelectorAll('.section-faq__item');
        hiddenItems.forEach((item) => {
          item.classList.remove('section-faq__item--active');
          const content = item.querySelector('.section-faq__item-content');
          if (content) {
            content.style.maxHeight = null;
          }
        });
      }
    });
  }

  /**
   * Setup accordion functionality
   */
  setupAccordion() {
    this.items.forEach((item) => {
      const header = item.querySelector('.section-faq__item-header');
      const content = item.querySelector('.section-faq__item-content');

      if (header && content) {
        header.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleItem(item, content);
        });
      }
    });
  }

  /**
   * Toggle accordion item
   * @param {HTMLElement} item - The FAQ item
   * @param {HTMLElement} content - The content element
   */
  toggleItem(item, content) {
    const isActive = item.classList.contains('section-faq__item--active');

    if (isActive) {
      // Close item
      item.classList.remove('section-faq__item--active');
      content.style.maxHeight = null;
    } else {
      // Open item
      item.classList.add('section-faq__item--active');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }
}

/**
 * Initialize all FAQ sections on the page
 */
function initFAQSections() {
  const faqSections = document.querySelectorAll('[data-section-type="w-faq"]');
  faqSections.forEach((section) => {
    new SectionFAQ(section);
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFAQSections);
} else {
  initFAQSections();
}

// Re-initialize on Shopify section load (theme editor)
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-section-type="w-faq"]')) {
      initFAQSections();
    }
  });
}
